/**
 * @constant {Object} pdfDocSections
 */
export const pdfDocSections = {
  PDF_DOC_HEADER: "PDF_DOC_HEADER",
  PDF_DOC_BODY: "PDF_DOC_BODY",
  PDF_DOC_FOOTER: "PDF_DOC_FOOTER",
  PDF_DOC_SIGNATURE: "PDF_DOC_SIGNATURE",
  PDF_DOC_PAGENUMBER: "PDF_DOC_PAGENUMBER",
};

/**
 * @constant {Object} adrSections - For AdrReviewMode
 */
export const adrSections = {
  ADR_SECTION_TITLE: "ADR_SECTION_TITLE",
  ADR_SECTION_HEADER: "ADR_SECTION_HEADER",
  ADR_SECTION_NARRATIVE: "ADR_SECTION_NARRATIVE",
  ADR_SECTION_LABOR: "ADR_SECTION_LABOR",
  ADR_SECTION_EQUIPMENT: "ADR_SECTION_EQUIPMENT",
  ADR_SECTION_QUANTITIES: "ADR_SECTION_QUANTITIES",
  ADR_SECTION_GENERALCOMMENTS: "ADR_SECTION_GENERALCOMMENTS",
  ADR_SECTION_TENTATIVEAGREEMENTS: "ADR_SECTION_TENTATIVEAGREEMENTS",
};
